import { FC, useState } from 'react';

import { DrawerContext, DrawerContextState } from './DrawerContext';

export const DrawerContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [isNavOpen, setIsNavOpen] = useState<boolean>(false);

  const context: DrawerContextState = {
    isDrawerOpen,
    isNavOpen,
    toggleDrawer: (newState?: boolean) => setIsDrawerOpen(newState ?? !isDrawerOpen),
    toggleNav: (newState?: boolean) => setIsNavOpen(newState ?? !isNavOpen),
  };

  return <DrawerContext.Provider value={context}>{children}</DrawerContext.Provider>;
};
